export enum ACADEMIC_TYPE {
  REGULAR = 'regular',
  AUDIT = 'audit',
  CREDIT = 'credit',
  UPGRADE = 'upgrade',
  CREDIT_PLUS = 'credit_plus',
  REGRADE = 'regrade',
}
